/**
 * SelectStore Component
 * @module views/components/SelectStore
 */
import './SelectStore.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import Text from '@ulta/core/components/Text/Text';

import { useFiltersColumnContext } from '@ulta/providers/FiltersColumnProvider/FiltersColumnProvider';

/**
 * Represents a Select Store Filter component
 * @method
 * @param {SelectStoreProps} props - React properties passed from composition
 * @returns SelectStore
 */
const SelectStore = ( props ) => {
  const { iconImage, label, selectAction, isSelectedStore } = props;
  const { loading } = useFiltersColumnContext();
  const storeName = isSelectedStore?.bopisStoreName;

  return (
    <div className='SelectStore'>
      <Text
        htmlTag='span'
        textStyle='body-2'
        color='neutral-600'
      >
        { label }
      </Text>
      <Button
        variant='linkSecondary'
        iconImage={ iconImage }
        iconPosition='after'
        label={ storeName }
        action={ selectAction }
        loading={ loading }
        ariaLabel={ storeName }
      />
    </div>
  );
};

/**
 * Property type definitions for SelectStore
 * @typedef {object} SelectStoreProps
 * @property {string} label - Label text displayed above the button
 * @property {function} selectAction - Action invoked on button click
 * @property {object} isSelectedStore - Currently selected store object
 * @property {string} [isSelectedStore.storeName] - Name of the selected store
 * @property {string} iconImage - Icon displayed next to the store name
 */
export const propTypes = {
  /** Label text displayed above the button */
  label: PropTypes.string,
  /** Action invoked on button click */
  selectAction: PropTypes.object,
  /** Currently selected store object */
  isSelectedStore: PropTypes.object,
  /** Icon displayed next to the store name */
  iconImage: PropTypes.string
};

SelectStore.propTypes = propTypes;

export default SelectStore;